import React from "react";
import { Alert } from "antd";
import { TYPE_ERROR } from "constants/ui.constants";

const FeedbackAlerts = ({ alertState, loading, safetyScanning, fileName, safetyCheckPassedFile }) => (
  <>
    {!loading && alertState && (
      <Alert
        type={alertState.type}
        showIcon
        closable
        title={alertState.description}
        style={{ marginTop: 12 }}
      />
    )}
    {!safetyScanning && fileName && safetyCheckPassedFile === false && (
      <Alert
        type={TYPE_ERROR}
        showIcon
        title={
          <><strong>Safety Check Failed</strong> —{" "}
            <a href="https://safety.google/content-safety/" target="_blank" rel="noopener noreferrer">
              Google Safety Check
            </a>{" "}
            Failed: {fileName}. Replace file.
          </>
        }
        style={{ marginTop: 12 }}
      />
    )}
  </>
);

export default FeedbackAlerts;
